export default "__VITE_ASSET__CXv$HTvS__"